var resolve = require('./resolve');
var request = require('./request');
var Promise = require('bluebird');
var config = require('./config');


exports.GetScheme = function(schemeId, grantRoundId) {
  return request.get(resolve(config.url(), '/scheme/' + schemeId + '?grantRoundId=' + grantRoundId )).promise();
}

exports.GetMatchingCriteria = function(schemeId){
  return request.get(resolve(config.url(), 'scheme/' + schemeId + '/matchingCriteria')).promise();
}

exports.GetSchemeAdministrators = function(schemeId) {
  return request.get(resolve(config.url(), 'scheme/' + schemeId + '/administrators')).promise();
}

exports.TitleUpdate = function(schemeId, title){
  return request.put(resolve(config.url(), 'scheme/' + schemeId + '/title'), {title: title }).promise();
}

exports.SubmitTermsAndConditionsDoc = function(schemeId, blobId, fileName, fileSize){
  return request.post(resolve(config.url(), 'scheme/' + schemeId + '/termsandconditions'),
    { blobId: blobId, fileName: fileName, fileSize: fileSize }).promise();
}

exports.DeleteTermsAndConditionsDoc = function(schemeId){
  return request.del(resolve(config.url(), 'scheme/' + schemeId + '/termsandconditions')).promise();
}

exports.DescriptionUpdate = function(schemeId, description){
  return request.put(resolve(config.url(), 'scheme/' + schemeId + '/description'), {description: description }).promise();
}

exports.PublicDescriptionUpdate = function (schemeId, publicDescription) {
    return request.put(resolve(config.url(), 'scheme/' + schemeId + '/publicdescription'), { publicDescription: publicDescription }).promise();
}

exports.FundAmountUpdate = function(schemeId, fundAmount){
  return request.put(resolve(config.url(), 'scheme/' + schemeId + '/fundamount'), {fundAmount: fundAmount }).promise();
}

exports.NextAwardedUpdate = function(schemeId, nextAwarded){
  return request.put(resolve(config.url(), 'scheme/' + schemeId + '/nextawarded'), {nextAwardedDate: nextAwarded }).promise();
}

exports.DeadlineUpdate = function(schemeId, deadline){
  return request.put(resolve(config.url(), 'scheme/' + schemeId + '/deadline'), {deadlineDate: deadline }).promise();
}

exports.GetAllMatchingCriteriaQuestionIds = function(schemeId) {
  return request.get(resolve(config.url(),'/scheme/' + schemeId + '/matchingcriteria/QuestionId/all')).promise();
}

exports.GetAllMatchingCriteriaSummaries = function(schemeId) {
  return request.get(resolve(config.url(),'/scheme/' + schemeId + '/matchingcriteria/summary/all')).promise();
}


exports.GetSingleMatchingCriteria = function(questionId, schemeId) {
  return request.get(resolve(config.url(),'/scheme/' + schemeId + '/matchingcriteria?questionId=' + questionId)).promise();
}


exports.CreateMatchingCriteria = function(matchingCriteria,schemeId) {
  return request.post(resolve(config.url(),'/scheme/' + schemeId + '/matchingcriteria'),matchingCriteria).promise();
}

exports.UpdateMatchingCriteria = function(matchingCriteria,schemeId) {
  return request.put(resolve(config.url(),'/scheme/' + schemeId + '/matchingcriteria'),matchingCriteria).promise();
}

exports.DeleteMatchingCriteria = function(schemeId, criteriaId){
  return request.del(resolve(config.url(), '/scheme/' + schemeId + '/match?criteriaId=' + criteriaId)).promise();
}


exports.GetAdditionalQuestions = function(schemeId){
  return request.get(resolve(config.url(),'/scheme/' + schemeId + '/additionalquestions')).promise();
}

exports.UpdateAdditionalQuestions = function(schemeId, data){
  return request.post(resolve(config.url(),'/scheme/' + schemeId + '/additionalquestions'),data).promise();
}

exports.GetDefaultGrantRound = function(schemeId, viewName){
  return request.get(resolve(config.url(),'/scheme/' + schemeId + '/grantround?viewName=' + viewName)).promise();
}

exports.GetGrantRounds = function(schemeId, showExpired, viewName, showArchived){
  return request.get(resolve(config.url(),'/scheme/' + schemeId + '/grantrounds?showExpired=' + showExpired + '&viewName=' + viewName + '&showArchived=' + showArchived)).promise();
}

exports.CreateGrantRound = function(schemeId, data){
  return request.post(resolve(config.url(),'/scheme/' + schemeId + '/grantround'),data).promise();
}

exports.UpdateGrantRound = function(schemeId, data){
  return request.put(resolve(config.url(),'/scheme/' + schemeId + '/grantround'),data).promise();
}

exports.SchemeStatusUpdate = function(schemeId, status){
  return request.put(resolve(config.url(), 'scheme/' + schemeId + '/status'), {status: status }).promise();
}

exports.GetFeeAndVat = function(fundsWithoutFee, feeRate) {
  return request.get(resolve(config.url(), 'scheme/GetFeeAndVat?fundsWithoutFee=' + fundsWithoutFee + '&feeRate=' + feeRate)).promise();
}
